import React from 'react';
import { InstagramIcon, MapPinIcon, MessageCircleIcon, ClockIcon } from 'lucide-react';
import { BowIcon } from './icons/NailIcons';
import { INSTAGRAM_URL, TIKTOK_URL, WHATSAPP_URL } from '../data/site';
function TikTokIcon({
  className = 'h-5 w-5'
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true" data-id="element-112" data-mp="36p6bgupomqa3">
      <path d="M16.5 2h-2.9v12.2a2.5 2.5 0 1 1-2.5-2.5c.2 0 .4 0 .6.1V8.8a5.5 5.5 0 1 0 4.8 5.4V8.9a6.2 6.2 0 0 0 3.5 1.1V7.1a3.6 3.6 0 0 1-3.5-3.6V2Z" data-id="element-113" data-mp="3ufa4671c15mb" />
    </svg>;
}
const navLinks = [{
  href: '#servicios',
  label: 'Servicios'
}, {
  href: '#sobre-mi',
  label: 'Sobre mí'
}, {
  href: '#trabajos',
  label: 'Trabajos'
}, {
  href: '#reservar',
  label: 'Reservar'
}];
export function Footer() {
  return <footer className="w-full bg-ink text-blush-100" data-id="element-114" data-mp="29zgnu9fpz8qc">
      <div className="mx-auto w-full max-w-7xl px-5 sm:px-8" data-id="element-115" data-mp="29xvrce9uhfpu">
        <div className="flex flex-col gap-5 border-b border-white/10 py-12 sm:flex-row sm:items-center sm:justify-between" data-id="element-116" data-mp="2eyjoziskwut1">
          <div data-id="element-117" data-mp="3la28msb12zu6">
            <p className="font-serif text-3xl font-semibold leading-tight text-white" data-id="element-118" data-mp="3lbmtfq7jj4eu">
              ¿Dudas? Escribinos por WhatsApp
            </p>
            <p className="mt-2 text-[0.95rem] text-blush-200/80" data-id="element-119" data-mp="3v7zx9gwsuynb">
              Te respondo personalmente y te asesoro antes de reservar.
            </p>
          </div>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full bg-fucsia px-8 py-4 text-base font-semibold text-white transition-[transform,background-color] duration-150 ease-smooth hover:-translate-y-0.5 hover:bg-blush-400 hover:text-fucsia-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blush-300" data-id="element-120" data-mp="830k9lv0mb22">
            <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-121" data-mp="ms6fkyqqfh4o" />
            Hablar por WhatsApp
          </a>
        </div>

        <div className="grid gap-10 py-12 sm:grid-cols-2 lg:grid-cols-4" data-id="element-122" data-mp="tw5wk16p5gk3">
          <div data-id="element-123" data-mp="yto901jxadwu">
            <p className="flex items-center gap-2.5 text-white" data-id="element-124" data-mp="ytef42vrbmlv">
              <BowIcon className="h-7 w-7 text-blush-300" data-id="element-125" data-mp="13taneebhm078" />
              <span className="font-serif text-2xl font-semibold" data-id="element-126" data-mp="13rpuet4tmpbh">Cami Nails</span>
            </p>
            <p className="mt-4 text-sm leading-relaxed text-blush-200/80" data-id="element-127" data-mp="18lk7hdpx861l">
              Estudio de uñas premium. Diseños personalizados, higiene garantizada y buena onda
              siempre.
            </p>
          </div>

          <div data-id="element-128" data-mp="1hmie83rqurnv">
            <h2 className="text-sm font-semibold uppercase tracking-wider text-blush-300" data-id="element-129" data-mp="1mk1rb0cpgye8">
              Contacto
            </h2>
            <ul className="mt-4 space-y-3 text-sm text-blush-100" data-id="element-130" data-mp="1rhttqoaz82wo">
              <li className="flex items-start gap-2.5" data-id="element-131" data-mp="3obeu9jv44w7n">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-blush-300" aria-hidden="true" data-id="element-132" data-mp="3oczpzct5yl73" />
                Prado, Montevideo, Uruguay
              </li>
              <li className="flex items-start gap-2.5" data-id="element-133" data-mp="2afdidco5p8os">
                <ClockIcon className="mt-0.5 h-4 w-4 shrink-0 text-blush-300" aria-hidden="true" data-id="element-134" data-mp="2agye35m7ixo8" />
                Lunes a sábado, con turno previo
              </li>
              <li className="flex items-start gap-2.5" data-id="element-135" data-mp="21nle5jpq6vsn">
                <MessageCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-blush-300" aria-hidden="true" data-id="element-136" data-mp="1wnz0xa9wdfju" />
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="underline decoration-white/25 underline-offset-4 transition-colors duration-150 ease-smooth hover:text-white" data-id="element-137" data-mp="2td6log2ozkmp">
                  Escribir por WhatsApp
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-138" data-mp="18zfocijtegly">
            <h2 className="text-sm font-semibold uppercase tracking-wider text-blush-300" data-id="element-139" data-mp="18vrypuhhqeci">
              Navegación
            </h2>
            <ul className="mt-4 space-y-3 text-sm" data-id="element-140" data-mp="2rvhglp6f6d8l">
              {navLinks.map(link => <li key={link.href} data-id="element-141" data-mp="2wmzkakzturx9">
                  <a href={link.href} className="text-blush-100 transition-colors duration-150 ease-smooth hover:text-white" data-id="element-142" data-mp="2wo0rufhmwwa8">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-143" data-mp="3bki2t5lww8w9">
            <h2 className="text-sm font-semibold uppercase tracking-wider text-blush-300" data-id="element-144" data-mp="3bhvydeubi9i9">
              Seguinos
            </h2>
            <div className="mt-4 flex items-center gap-3" data-id="element-145" data-mp="31m2dn86g39pe">
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label="Instagram de Cami Nails" className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-blush-100 transition-colors duration-150 ease-smooth hover:border-blush-300 hover:text-white" data-id="element-146" data-mp="31nn5ur5aegk3">
                <InstagramIcon className="h-5 w-5" aria-hidden="true" data-id="element-147" data-mp="1nnsh9yqw635w" />
              </a>
              <a href={TIKTOK_URL} target="_blank" rel="noopener noreferrer" aria-label="TikTok de Cami Nails" className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-blush-100 transition-colors duration-150 ease-smooth hover:border-blush-300 hover:text-white" data-id="element-148" data-mp="1ioz0nxgb5w1i">
                <TikTokIcon data-id="element-149" data-mp="zuk0w5m69zcm" />
              </a>
            </div>
            <p className="mt-4 text-sm text-blush-200/80" data-id="element-150" data-mp="1dojp9bfl6ym6">@ccamila_nnails</p>
          </div>
        </div>

        <div className="flex flex-col gap-2 border-t border-white/10 py-7 text-xs text-blush-200/70 sm:flex-row sm:items-center sm:justify-between" data-id="element-151" data-mp="18vi8syzqer0h">
          <p data-id="element-152" data-mp="g8nny0z05pmh">© {new Date().getFullYear()} Cami Nails. Todos los derechos reservados.</p>
          <p data-id="element-153" data-mp="2gan9w6kgdv2d">Prado, Montevideo · Turnos con seña del 50%</p>
        </div>
      </div>
    </footer>;
}